import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { ArrowRight, Gamepad2, Gem } from "lucide-react"

export default function AboutPreview() {
  return (
    <section className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left — Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-yellow-700/30 bg-yellow-900/10 mb-6">
              <Gem className="w-4 h-4 text-yellow-500" />
              <span className="text-yellow-400 text-xs font-semibold uppercase tracking-widest">
                About Us
              </span>
            </div>

            <h2
              className="text-3xl sm:text-4xl font-black uppercase tracking-tight mb-6"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              <span className="text-white">Style Meets </span>
              <span className="gold-shimmer">Skill</span>
            </h2>

            <p className="text-gray-400 text-lg leading-relaxed mb-4">
              BlingSkins.com is the home for gamers who care about style as much as skill. We believe that looking good in-game is half the battle won.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Our team of dedicated gaming enthusiasts scours every update, event, and drop to bring you the most comprehensive guides to the flashiest, rarest, and most luxury-themed cosmetics in gaming. From gold-plated weapons to diamond-encrusted character skins, if it shines, we cover it.
            </p>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-yellow-500 hover:text-yellow-400 font-semibold uppercase tracking-wider transition-colors group"
            >
              Read Our Story
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>

          {/* Right — Visual */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden border border-gray-800/50 glow-gold">
              <div className="aspect-video bg-gradient-to-br from-gray-900 via-gray-950 to-black flex items-center justify-center">
                <div className="text-center">
                  <Gamepad2 className="w-16 h-16 text-yellow-600/40 mx-auto mb-4" />
                  <p
                    className="text-yellow-600/60 text-sm uppercase tracking-widest font-semibold"
                    style={{ fontFamily: "'Orbitron', sans-serif" }}
                  >
                    Gaming Aesthetics
                  </p>
                  <p className="text-gray-600 text-xs mt-1">Since 2024</p>
                </div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full bg-yellow-500/5 blur-2xl" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 rounded-full bg-cyan-500/5 blur-2xl" />
          </motion.div>
        </div>
      </div>
    </section>
  )
}
